export const DISPLAY_WARNING = 'DISPLAY_WARNING';
export const CONFIRM_WARNING = 'CONFIRM_WARNING';
export const CLOSE_WARNING = 'CLOSE_WARNING';

export function displayWarning() {
  return { type: DISPLAY_WARNING };
}

function warningConfirmed() {
  return { type: CONFIRM_WARNING };
}

export function confirmWarning() {
  return (dispatch, store, { router }) => {
    dispatch(warningConfirmed());
    router.push('/webshop/cancelChanges.do');
  };
}

export function closeWarning() {
  return { type: CLOSE_WARNING };
}
